



























import Push from 'push.js';
import moment from 'moment-timezone';
import { firebaseApp } from '@/firebase';
import { Component, Vue, Watch } from 'vue-property-decorator';
import constants from '@/utils/constants';

@Component
export default class FirebaseMessage extends Vue {
  alertMessage: string = 'New Order! ';
  showAlert: boolean = false;
  timeCounter: any = 0;
  allNewOrder: Array<any> = [];
  numParseInt: any;
  isOrderCount: boolean = false;
  // New order count
  qroNewOrderCount: any = null;
  hmdNewOrderCount: any = null;
  ppdiNewOrderCount: any = null;
  pptaNewOrderCount: any = null;
  topNewOrderCount: any = null;

  mounted() {
    if (
      !window.navigator.userAgent.includes('iPhone') &&
      !window.navigator.userAgent.includes('Android') &&
      !window.navigator.userAgent.includes('ipad')
    ) {
      this.getNewOrderRequest();
      this.ckeckOutNewOrder();
    }
    if (localStorage.getItem('UID') === null) {
      this.logOut();
    }
  }

  beforeDestroy() {
    this.$store.commit('SET_NEW_ORDER_NUMBER', undefined);
    this.$store.commit('SET_NEW_HMD_ORDER_NUMBER', undefined);
    this.$store.commit('SET_ACTIVE_ORDERTYPE', undefined);
    window.clearTimeout(this.timeCounter);
    this.timeCounter = 0;
    this.queryTheNewOrder = () => {
      return false;
    };
  }

  logOut() {
    if (window && typeof (window as any).android !== 'undefined') {
      (window as any).android.unsetFirebaseToken();
    }
    if (window && typeof (window as any).webkit !== 'undefined') {
      (window as any).webkit.messageHandlers.sendUserInfo.postMessage({
        userID: '',
        isSign: false
      });
    }
    this.$store.dispatch('LOAD_CURRENT_USER', { uid: '' });
    this.$store.dispatch('LOAD_USER_PRIVILEGES', '');
    firebaseApp
      .auth()
      .signOut()
      .then(data => {
        this.$router.push('login');
      });
  }

  get newOrderNumber() {
    return this.$store.getters.GetNewOrderNumber;
  }
  get newHMDOrderNumber() {
    return this.$store.getters.GetNewHMDOrderNumber;
  }
  get isVoiceShow() {
    return this.$store.getters.GetIsVoiceShow;
  }

  get newOrderCounts() {
    return this.$store.getters.GetAllNewOrderCounts;
  }

  ckeckOutNewOrder() {
    if (localStorage.getItem('allNewOrder')) {
      this.allNewOrder = JSON.parse(localStorage.getItem('allNewOrder') as any);
      if (this.allNewOrder.length > 0) {
        this.showAlert = true;
      } else {
        this.showAlert = false;
      }
    }
  }

  checkOutTime() {
    this.numParseInt = localStorage.getItem('time');
    const nowTime = moment(moment().format('YYYY-MM-DD')).valueOf();
    if (!this.numParseInt) {
      localStorage.setItem('time', JSON.stringify(nowTime));
    }
    if (parseInt(this.numParseInt) < nowTime) {
      localStorage.removeItem('allNewOrder');
      localStorage.removeItem('time');
    }
  }

  queryTheNewOrder() {
    this.timeCounter = window.setTimeout(() => {
      this.getNewOrderRequest();
    }, 15000);
  }

  getNewOrderRequest() {
    this.$store
      .dispatch('GetNewOrder', localStorage.getItem('UID'))
      .then(res => {
        if (res.result.QRO) {
          this.qroNewOrderCount = res.result.QRO.count;
        }
        if (res.result.HMD) {
          this.hmdNewOrderCount = res.result.HMD.count;
        }
        if (res.result.PPDI) {
          this.ppdiNewOrderCount = res.result.PPDI.count;
        }
        if (res.result.PPTA) {
          this.pptaNewOrderCount = res.result.PPTA.count;
        }
        if (res.result.TOP) {
          this.topNewOrderCount = res.result.TOP.count;
        }
        this.queryTheNewOrder();
        localStorage.setItem('newOrderCounts', JSON.stringify(res.result));
        this.isOrderCount = true;
      });
  }

  closeNewOrderAlert() {
    this.showAlert = false;
    this.allNewOrder = [];
    localStorage.setItem('allNewOrder', JSON.stringify(this.allNewOrder));
  }

  @Watch('isOrderCount')
  watchStatus() {
    if (this.isOrderCount) {
      if (JSON.parse(localStorage.getItem('newOrderCounts') as any).QRO) {
        this.qroNewOrderCount = JSON.parse(localStorage.getItem(
          'newOrderCounts'
        ) as any).QRO.count;
      }
      if (JSON.parse(localStorage.getItem('newOrderCounts') as any).HMD) {
        this.hmdNewOrderCount = JSON.parse(localStorage.getItem(
          'newOrderCounts'
        ) as any).HMD.count;
      }
      if (JSON.parse(localStorage.getItem('newOrderCounts') as any).PPDI) {
        this.ppdiNewOrderCount = JSON.parse(localStorage.getItem(
          'newOrderCounts'
        ) as any).PPDI.count;
      }
      if (JSON.parse(localStorage.getItem('newOrderCounts') as any).PPTA) {
        this.pptaNewOrderCount = JSON.parse(localStorage.getItem(
          'newOrderCounts'
        ) as any).PPTA.count;
      }
      if (JSON.parse(localStorage.getItem('newOrderCounts') as any).TOP) {
        this.topNewOrderCount = JSON.parse(localStorage.getItem(
          'newOrderCounts'
        ) as any).TOP.count;
      }
    }
  }

  @Watch('qroNewOrderCount')
  watchQROOrder(newValue, oldValue) {
    if (newValue > oldValue && oldValue !== null) {
      this.showAlert = true;
      this.pushMessage(constants.QRO);
      this.allNewOrder.push(constants.QRO);
      localStorage.setItem('allNewOrder', JSON.stringify(this.allNewOrder));
    }
  }

  @Watch('hmdNewOrderCount')
  watchHMDOrder(newValue, oldValue) {
    if (newValue > oldValue && oldValue !== null) {
      this.showAlert = true;
      this.pushMessage(constants.HMD);
      this.allNewOrder.push(constants.HMD);
      localStorage.setItem('allNewOrder', JSON.stringify(this.allNewOrder));
    }
  }

  @Watch('ppdiNewOrderCount')
  watchPPDIOrder(newValue, oldValue) {
    if (newValue > oldValue && oldValue !== null) {
      this.showAlert = true;
      this.pushMessage(constants.PPDI);
      this.allNewOrder.push(constants.PPDI);
      localStorage.setItem('allNewOrder', JSON.stringify(this.allNewOrder));
    }
  }

  @Watch('pptaNewOrderCount')
  watchPPTAOrder(newValue, oldValue) {
    if (newValue > oldValue && oldValue !== null) {
      this.showAlert = true;
      this.pushMessage(constants.PPTA);
      this.allNewOrder.push(constants.PPTA);
      localStorage.setItem('allNewOrder', JSON.stringify(this.allNewOrder));
    }
  }

  @Watch('topNewOrderCount')
  watchTOPOrder(newValue, oldValue) {
    if (newValue > oldValue && oldValue !== null) {
      this.showAlert = true;
      this.pushMessage(constants.TOP);
      this.allNewOrder.push(constants.TOP);
      localStorage.setItem('allNewOrder', JSON.stringify(this.allNewOrder));
    }
  }

  pushMessage(itemMessage) {
    Push.create('New Order!', {
      body: 'Click here to get it !',
      requireInteraction: true,
      icon: require('@/assets/logo.png'),
      tag: itemMessage,
      link: 'https://qraved-order-dev.web.app/order-report',
      onClick: () => {
        window.focus();
        this.handleMessageLinkClick();
        Push.close(itemMessage);
      }
    });
  }

  handleMessageLinkClick() {
    this.$store.commit('SET_IS_NEW_ORDER', true);
    let orderType: any = [
      constants.QRO,
      constants.HMD,
      constants.PPDI,
      constants.PPTA,
      constants.TOP
    ];
    let localType: any = JSON.parse(localStorage.getItem('allNewOrder') as any);
    orderType.map(v => {
      if (localType[0] === v) {
        this.$store.commit('SET_ACTIVE_ORDERTYPE', v);
        this.allNewOrder.shift();
        localStorage.setItem('allNewOrder', JSON.stringify(this.allNewOrder));
      }
    });
    if (this.allNewOrder.length > 0) {
      this.showAlert = true;
    } else {
      this.showAlert = false;
    }
    this.$store.commit('SET_NEWORDER_COMING', 1);
  }
}
